// extracted by mini-css-extract-plugin
export default {"card":"OverviewCashbackWidget_card__LL1ZC"};